export const UNIVERSAL_GLYPH = '⁂';
// Publisher folders are marked with a globe. The trailing invisible character
// (U+FE0E) asks the OS to draw it as a flat black-and-white glyph instead of a
// color emoji — though some platforms ignore that and still show it in color.
export const PUBLISHER_GLYPH = '🌐︎';

const escapeRegExp = str => str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

// Remove a leading type glyph (and the space after it) from a folder name, so
// the dialog can show a clean name without the marker. We don't know which glyph
// a name starts with, so we build a pattern that matches either the universal or
// the publisher glyph and strip the first one we find.
//
// The globe glyph is tricky: it's a multi-character emoji that may carry a hidden
// "variation selector" after it. So we match on the plain glyph and then also
// swallow any trailing selector, which lets us strip a name whether or not it was
// stored with that hidden character.
export const stripFolderGlyphs = (name = '') => {
  const base = [UNIVERSAL_GLYPH, PUBLISHER_GLYPH]
    // Reduce each glyph to its plain form by dropping any variation selector.
    // Spreading the string walks it one emoji at a time so the globe stays whole.
    .map(glyph =>
      [...glyph]
        .filter(ch => {
          const cp = ch.codePointAt(0);
          return cp < 0xfe00 || cp > 0xfe0f; // 0xFE00–0xFE0F are the variation selectors
        })
        .join('')
    )
    .map(escapeRegExp)
    .join('|');
  return name
    .replace(new RegExp(`^\\s*(?:${base})[\\uFE0E\\uFE0F]?\\s*`), '')
    .trimStart();
};

// Return the name carrying exactly the glyph for the given type (or none).
// Strips any existing glyph first so it never stacks two when the type changes
// (universal ⇄ publisher) and a user folder never keeps a stale glyph.
export const prefixFolderGlyph = (
  name = '',
  { isUniversal, isPublisherFolder } = {}
) => {
  const base = stripFolderGlyphs(name);
  if (isUniversal) return `${UNIVERSAL_GLYPH} ${base}`;
  if (isPublisherFolder) return `${PUBLISHER_GLYPH} ${base}`;
  return base;
};
